"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.API_ROUTES = void 0;
exports.API_ROUTES = {
    COUNTER_AGGREGATED_INCREMENT: '/api/v1/counter-aggregated_increment',
    GAUGE_RAW_SET: '/api/v1/gauge-raw_set',
    GAUGE_RAW_SET_MANY: '/api/v1/gauge-raw_set-many',
    HISTOGRAM_AGGREGATED_OBSERVE: '/api/v1/histogram-aggregated_observe',
};
//# sourceMappingURL=routes.js.map